<template>
  <v-container>
    <v-card class="mt-4 me-lg-5">
      <v-card-item>
        <v-card-title><strong>chatSO</strong> - Release Notes</v-card-title>
      </v-card-item>
      <v-card-text class="justify">
        <h3>v2026-04-11.0</h3>
        <ul>
          <li>Sources citées avec liens cliquables : format <em>nom (source : [lien](url))</em> dans les réponses</li>
          <li>Correction de l'affichage markdown des listes dans les réponses (CSS Vuetify)</li>
          <li>Correction du conseil sur l'archivage : distinction entre archivage pérenne et dépôt de partage</li>
          <li>Déploiement entièrement containerisé Docker : build local, venv hôte monté, frontend servi depuis le dist pré-buildé</li>
          <li>Paramètre MAX_TOKENS porté à 2048 (réponses plus complètes)</li>
        </ul>

        <h3>v2026-03-18.0</h3>
        <ul>
          <li>Page Ressources entièrement refondue : 221 sources disponibles (vs 29 précédemment)</li>
          <li>Filtres par discipline et par thématique sur la page Ressources + recherche textuelle</li>
          <li>Affichage enrichi des ressources : discipline, thèmes, date de mise à jour</li>
          <li>Synchronisation automatique de la liste des ressources vers le frontend après chaque mise à jour de la base de connaissances</li>
          <li>Correction de l'affichage des avertissements Unstructured (un seul message au démarrage)</li>
          <li>Correction de la normalisation des identifiants de documents (comparaison float/string)</li>
        </ul>

        <h3>v2025-11-27.0</h3>
        <ul>
          <li>Support des fichiers Markdown dans le système RAG</li>
          <li>Intégration de contenus web : entrepôts de confiance (recherche.data.gouv.fr) et JurisDoR (jurisdor.fr)</li>
          <li>Système d'évaluation des réponses (notes 1-5 étoiles) avec base SQLite</li>
          <li>URLs cliquables dans les réponses (ouverture en nouvel onglet)</li>
          <li>Historique des conversations sauvegardé localement (30 jours, jusqu'à 20 conversations)</li>
          <li>Gestion multi-conversations accessible via le menu burger</li>
          <li>Détection automatique du dépassement de contexte du modèle</li>
          <li>Protection anti-abus : rate limiting nginx + fail2ban (scanners et API)</li>
          <li>Mapping automatique des URLs pour les fichiers Markdown</li>
          <li>Amélioration du disclaimer juridique dans le system prompt</li>
          <li>Base RAG étendue à 12,813 chunks (206 documents : 200 PDF + 6 Markdown)</li>
          <li>Optimisation des paramètres de recherche RAG (100 résultats, rerank top 10)</li>
        </ul>

        <h3>v2025-10-06.0</h3>
        <ul>
          <li>Migration vers OpenAI-compatible API (gateway-ia.app.unistra.fr)</li>
          <li>Support de multiples modèles (gpt-oss, qwen3, lucie, mistral-small)</li>
          <li>Page de test et comparaison de modèles (/modeltesting)</li>
          <li>Amélioration du rendu markdown dans les réponses</li>
          <li>Déploiement en production avec nginx et SSL</li>
          <li>Optimisation de l'espace disque et performances</li>
        </ul>

        <h3>v2025-01-21.0</h3>
        <ul>
          <li>Prise en compte du markdown avec vue-markdown</li>
        </ul>

        <h3>v2025-01-20.0</h3>
        <ul>
          <li>Remise à zéro de la question après réponse du chat - amélioration CSS</li>
        </ul>

        <h3>v2025-01-15.0</h3>
        <ul>
          <li>Test du modèle Lucie</li>
        </ul>

        <h3>v2025-01-08.0</h3>
        <ul>
          <li>Activation du captcha en préproduction</li>
          <li>Ajout de l'étape docker login dans la documentation Docker</li>
        </ul>

        <h3>v2024-11-29.0</h3>
        <ul>
          <li>Création d'un menu Ressources et de la page correspondante (lien vers tous les PDFs)</li>
        </ul>

        <h3>v2024-10-24.0</h3>
        <ul>
          <li>Amélioration du prompt</li>
        </ul>

        <h3>v2024-10-21.0</h3>
        <ul>
          <li>Utilisation des images du registry GitLab dans docker-compose</li>
          <li>Paramètres du LLM déplacés dans le fichier .env</li>
        </ul>

        <h3>v2024-09-23.0</h3>
        <ul>
          <li>Utilisation d'Axios au lieu de stream avec server-sent events</li>
          <li>Passage à llama3 comme LLM</li>
          <li>Mode préproduction par défaut</li>
        </ul>

        <h3>v2024-09-17.0</h3>
        <ul>
          <li>Configuration docker-compose avec Ollama</li>
        </ul>

        <h3>v2024-09-13.0</h3>
        <ul>
          <li>Intégration RAG + LLM avec Ollama</li>
        </ul>

        <h3>v2023-11-23.0</h3>
        <ul>
          <li>Dockerisation du front et docker-compose (premier test)</li>
        </ul>

        <h3>v2023-11-15.0</h3>
        <ul>
          <li>Évaluation des réponses du modèle</li>
        </ul>

        <h3>v2023-10-25.0</h3>
        <ul>
          <li>Version avec prise en compte de l'historique de discussion</li>
        </ul>

        <h3>v2023-08-21.0</h3>
        <ul>
          <li>Ajout d'un captcha</li>
        </ul>

        <h3>v2023-08-17.0</h3>
        <ul>
          <li>Ajustement du site pour sa version mobile</li>
        </ul>

        <h3>v2023-07-20.0</h3>
        <ul>
          <li>Migration de Vue.js 2 vers Vue.js 3</li>
          <li>Adaptation de la charte RDG (Couleurs) + logos au frontend</li>
        </ul>

        <h3>v2023-07-19.0</h3>
        <ul>
          <li>Réception des réponses du serveur en temps réel</li>
        </ul>

        <h3>v2023-07-11.0</h3>
        <ul>
          <li>Test d'utilisation des Server Sent Events avec FastAPI</li>
          <li>Modèle vigogne avec llama-cpp</li>
        </ul>

        <h3>v2023-07-07.0</h3>
        <ul>
          <li>Version initiale du projet</li>
        </ul>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "VersionChatRDG",
  props: [],
  components: {},
  data: () => ({}),
};
</script>

<style></style>
